import * as API from "@/services/API";

export default {
  getField() {
    return API.apiClient.get("/faqs-questions-answers");
  },
};
